export function checkUrlForFilters(searchParams: URLSearchParams) {
  const keys = [
    "regions",
    "prompt",
    "fundingMin",
    "fundingMax",
    "financialStages",
    "listIds",
    "lastFundingDateFrames",
    "clearTags"
  ];
  return keys.some((key) => searchParams.has(key));
}
